import React from 'react';
import { CommonCustomerItem } from 'types';

import styles from './ProductPage.module.scss';
import { Brands } from '../../components/Brands';

export type SimilarBrandsProps = {
  brands: Array<CommonCustomerItem>;
};

export const SimilarBrands = ({ brands }: SimilarBrandsProps) => {
  if (!brands?.length) {
    return null;
  }

  return (
    <div className={styles.related}>
      <h2 className={styles.relatedTitle}>Brands Your Friends Like</h2>
      <div className={styles.relatedItems}>{brands.map((item: CommonCustomerItem) => (
        <Brands
          key={item.id}
          brand={item}
          type={'common'}
          withOpacity={false}
        />
      ))}</div>
    </div>
  );
};
